var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgB2ShowerStormAndSunDay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#B2_Shower_storm_and_sun_day_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M76 28a2 2 0 01-2 2h-7a2 2 0 110-4h7a2 2 0 012 2zM62 18a2 2 0 001.42-.59l4.94-5a2 2 0 00-2.82-2.82l-5 4.94A2 2 0 0062 18zm1.42 20.63a2.002 2.002 0 00-2.83 2.83l5 4.94a2 2 0 002.82 0 2 2 0 000-2.82l-4.99-4.95zM50 18a10 10 0 00-7.65 3.57 19.48 19.48 0 015.46 8.5 15.48 15.48 0 019.59 4.64A10 10 0 0050 18zm-3.85 16.92h-1.78a15.3 15.3 0 00-4.68-9 15.56 15.56 0 00-26 9h-1.84a11.5 11.5 0 100 23H20v-3.84h-8.15a7.67 7.67 0 110-15.33h5.41v-1.86a11.72 11.72 0 0119.75-8.18 11.54 11.54 0 013.63 8.17v1.87h5.41a7.669 7.669 0 110 15.33H44v3.84h2.15a11.5 11.5 0 000-23zM50 13a2 2 0 002-2V4a2 2 0 10-4 0v7a2 2 0 002 2zM39.9 43H31l-7 14.94V58h5.85l-6.18 14.8L40.74 54h-9.62l8.78-11zm-3.34-25.61a2 2 0 002.553.273 2 2 0 00.297-3.083l-5-4.94a2 2 0 00-2.82 2.82l4.97 4.93z",
    fill: "currentColor"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "B2_Shower_storm_and_sun_day_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h76v76H0z"
  })))));
}
export default __webpack_public_path__ + "static/media/B2_Shower_storm_and_sun_day.748d38b0.svg";
export { SvgB2ShowerStormAndSunDay as ReactComponent };